import { createFileRoute } from "@tanstack/react-router";

import { parseWalletSearch } from "@/features/money";
import { WalletPage } from "@/features/money/pages";
import { strictSearch } from "@/shared/lib/search";

/** A specialist's wallet: that of the provider she works through, reached from her page. */
export const Route = createFileRoute("/_app/money/specialists/$userId")({
  validateSearch: strictSearch(parseWalletSearch),
  component: SpecialistWallet,
});

function SpecialistWallet() {
  const { userId } = Route.useParams();
  const search = Route.useSearch();
  const navigate = Route.useNavigate();
  return (
    <WalletPage
      key={userId}
      owner={{ by: "specialist", id: userId }}
      search={search}
      onSearchChange={(next) => void navigate({ search: next, replace: true })}
    />
  );
}
